export default __webpack_public_path__ + "static/media/moreAccessoriesInactive.d9e1a972.svg";